import React from "react";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import AnimatedModal from "./ui/AnimatedModal";
import { Button } from "./ui";

const DeleteConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  title = "Delete Document",
  message = "Are you sure you want to delete this document? This action cannot be undone.",
  documentName = "",
  /** Label before highlighted name (e.g. "Document", "Container"). */
  nameLabel = "Document",
  isLoading = false,
}) => {
  return (
    <AnimatedModal
      isOpen={isOpen}
      onClose={onClose}
      closeOnBackdrop
      zIndex="z-[9999]"
      contentClassName="bg-white overflow-hidden shadow-xl border border-gray-100 max-w-lg w-full"
    >
      <div className="px-4 pt-5 pb-4 sm:p-6">
        <div className="sm:flex sm:items-start">
          <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
            <ExclamationTriangleIcon className="h-6 w-6 text-red-600" />
          </div>
          <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left flex-1">
            <h3 className="text-lg font-medium text-gray-900">{title}</h3>
            <div className="mt-2">
              <p className="text-sm text-gray-500">{message}</p>
              {documentName && (
                <p className="mt-2 text-sm font-medium text-gray-900">
                  {nameLabel}:{" "}
                  <span className="text-red-600">{documentName}</span>
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse sm:gap-3">
        <Button
          type="button"
          variant="danger"
          size="default"
          onClick={onConfirm}
          disabled={isLoading}
          loading={isLoading}
        >
          {isLoading ? "Deleting..." : "Delete"}
        </Button>
        <Button
          type="button"
          variant="outline"
          size="default"
          onClick={onClose}
          disabled={isLoading}
        >
          Cancel
        </Button>
      </div>
    </AnimatedModal>
  );
};

export default DeleteConfirmationModal;
